// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import {
  dateSchema,
  loadEventSchema,
  loadStateOptions,
} from "../commonSchemas";

export const path = "get-loads";

export const loadSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: dateSchema,
  sourceLocation: z.string(),
  destinationLocation: z.string(),
  pickupStart: dateSchema.nullable(),
  pickupEnd: dateSchema.nullable(),
  deliveryEta: dateSchema.nullable(),
  deliveryStart: dateSchema.nullable(),
  deliveryEnd: dateSchema.nullable(),
  status: z.enum(loadStateOptions),
  weight: z.number().nullable(),
  receiverCost: z.number().nullable(),
  carrierId: z.string().nullable(),
  carrierPay: z.number().nullable(),
  carrierName: z.string().nullable(),
  driverName: z.string().nullable(),
  driverLicenseNumber: z.string().nullable(),
  truckLicensePlate: z.string().nullable(),
  truckVinLast6: z.string().nullable(),
  trailerLicensePlate: z.string().nullable(),
  trailerNumber: z.string().nullable(),
  pieces: z.number().nullable(),
  notes: z.string().nullable(),
  bol: z.string().nullable(),
  events: z.array(loadEventSchema),
});

export const getLoadsResponseSchema = z.array(loadSchema);




export type Load = z.infer<typeof loadSchema>;

export type GetLoadsResponse = z.infer<typeof getLoadsResponseSchema>;




// loads/get-loads endpoint
export function getLoads(
): Promise<GetLoadsResponse> {
  return requestHandler(
    "loads/get-loads",
    undefined,
    getLoadsResponseSchema,
  );
}

